import React, { Component } from 'react'
import { Select } from '@driftt/tide'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from 'modules/knowledgebase/actions'
import cx from 'classnames'

import { getDropdownOptions } from 'modules/knowledgebase/selectors'

import './style.css'

class CategorySelector extends Component {
  
  handleSelectChange = option => {
    const { actions } = this.props
    option.option.categoryId ?
      actions.setArticleSection({sectionId: option.option.id, categoryId: option.option.categoryId}) :
      actions.setArticleCategory(option.option.id)
  }
  
  renderOption = option => {
    return (
      <span
        className={cx({'article-editor-bar-category-select-section': option.option.categoryId})}
      >
        {option.label}
      </span>
    )
  }
  
  render () {
    const { articleCatId, article, options, selectedCategory } = this.props
    const articleSection = article.categoryId ? options.find(option => option.id === article.sectionId) : null
    
    if (!article.categoryId) article.categoryId = articleCatId
    
    const label = articleSection && articleSection.id ?
      `${selectedCategory.name} / ${articleSection.name}` :
        selectedCategory.name
    
    const value = articleSection && articleSection.id ?
      `section-${articleSection.id}` :
      `category-${selectedCategory.id}`
    
    return (
      <div className="article-editor-bar-select-wrapper">
        <Select
          size="small"
          clearable={false}
          className="article-editor-bar-category-select"
          value={{value, label}}
          onChange={this.handleSelectChange}
          options={options.map(
            option => {
              const value = option.categoryId ? `section-${option.id}` : `category-${option.id}`
              return {value, label: option.name, option}
            })}
          optionRenderer={this.renderOption}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  options: getDropdownOptions(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setArticleSection: actions.setArticleSection,
    setArticleCategory: actions.setArticleCategory,
  }, dispatch)
})
export default connect(mapStateToProps, mapDispatchToProps)(CategorySelector)